export default "__VITE_ASSET__497b5e21__"